import { render, staticRenderFns } from "./QRPage3.vue?vue&type=template&id=c3b4cc8a&lang=pug&"
import script from "./QRPage3.vue?vue&type=script&lang=js&"
export * from "./QRPage3.vue?vue&type=script&lang=js&"
import style0 from "./QRPage3.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports